import { render, staticRenderFns } from "./bannerComp.vue?vue&type=template&id=45a0f846"
import script from "./bannerComp.vue?vue&type=script&lang=js"
export * from "./bannerComp.vue?vue&type=script&lang=js"
import style0 from "./bannerComp.vue?vue&type=style&index=0&id=45a0f846&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports